module.exports = __webpack_public_path__ + "img/twitter.114f59a3.svg";